import React, { useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../../components/Loader'

import AddPosTask from './AddPosTask'
import { useAuditTask } from '../../../hooks/Others/Audit/useAuditTask'
import { OtherContext } from '../../../context api/Others/OtherContext'
export default function EditPosTask() {
  const { getAllAuditTask, loading } = useAuditTask()
  const { auditTasks } = useContext(OtherContext)
  const params = useParams()

  useEffect(() => {
    getAllAuditTask({ taskId: params.taskId, taskType: 'POS' })
  }, [params.taskId])

  return <> {loading ? <Loader /> : <AddPosTask task={auditTasks[0]} />} </>
}
